<template>
  <v-container>
    <v-row justify="center" alignment="center">
      <v-col cols="12" md="8" class="text-center">
        <h1>Thanks!</h1>
        <h3>Thanks for entering your receipt details - We've verified your purchase!</h3>
        <h3>Your unique claim reference is [[REFERENCE]]</h3>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Thanks',
  created() {
  },
  data: () => ({
    
  }),
};
</script>
